import React from 'react';

interface ServerTagsProps {
  tags: string[];
  className?: string;
}

const ServerTags: React.FC<ServerTagsProps> = ({ 
  tags,
  className = ''
}) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {tags.map((tag, index) => (
        <span 
          key={index} 
          className="px-2 py-1 bg-blue-900 text-blue-300 text-xs font-medium rounded"
        >
          {tag}
        </span>
      ))}
    </div>
  );
};

export default ServerTags;